import { AxeptioListener } from '@insify/axeptio-listener';
import { ModalProvider } from '@insify/modal';

import { useProfile } from './api/queries/useProfile';
import { FullScreenSpinner } from './components/FullScreenSpinner';
import { ObjectivTrackerProvider } from './components/ObjectivTrackerProvider';
import { WineProvider } from './components/WineProvider';
import { AppRouter } from './routes';
import { useAuthStore } from './stores/authStore';

const ConnectedSpinner = () => {
  const { data } = useProfile();
  const isAuthComplete = useAuthStore((state) => state.isAuthComplete);
  const hasAccessToken = useAuthStore((state) => Boolean(state.accessToken));

  const isAppReady = isAuthComplete && (!hasAccessToken || (hasAccessToken && Boolean(data)));

  return <FullScreenSpinner show={!isAppReady} />;
};

const App = () => (
  <>
    <AxeptioListener>
      {(isConsentGiven) => (
        <ObjectivTrackerProvider isConsentGiven={isConsentGiven}>
          <ModalProvider>
            <AppRouter />
          </ModalProvider>
        </ObjectivTrackerProvider>
      )}
    </AxeptioListener>
    <ConnectedSpinner />
    <WineProvider />
  </>
);

export { App };
